/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Certificate56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M17 40a6 6 0 110 12 6 6 0 010-12zM40 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M45 15a2 2 0 012 2v23a2 2 0 01-2 2H11a2 2 0 01-2-2V17a2 2 0 012-2h34z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M46 12c2.21 0 4 1.79 4 4v25c0 2.21-1.79 4-4 4H10c-2.21 0-4-1.79-4-4V16c0-2.21 1.79-4 4-4h36zm-1 2H11a3 3 0 00-3 3v23a3 3 0 003 3h34a3 3 0 003-3V17a3 3 0 00-3-3z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M46 10a6 6 0 016 6v25a6 6 0 01-6 6H10a6 6 0 01-6-6V16a6 6 0 016-6zm0 2H10c-2.21 0-4 1.79-4 4v25c0 2.21 1.79 4 4 4h36c2.21 0 4-1.79 4-4V16c0-2.21-1.79-4-4-4zm-1 2a3 3 0 013 3v23a3 3 0 01-3 3H11a3 3 0 01-3-3V17a3 3 0 013-3zm0 1H11a2 2 0 00-2 2v23a2 2 0 002 2h34a2 2 0 002-2V17a2 2 0 00-2-2zM23.5 35a.5.5 0 010 1h-9a.5.5 0 010-1h9zm0-3a.5.5 0 010 1h-9a.5.5 0 010-1h9zm0-3a.5.5 0 010 1h-9a.5.5 0 010-1h9zM33 19a1 1 0 010 2H23a1 1 0 010-2h10z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M39 40v8.625l-2.692-.87-.122-.032a1.022 1.022 0 00-.494.031L33 48.625V40h6z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M36 25a8 8 0 015 14.245V50a1 1 0 01-1.308.951L36 49.756l-3.692 1.195a1 1 0 01-1.301-.833L31 50V39.246A8 8 0 0136 25zm0 16a7.98 7.98 0 01-3-.582v8.207l2.692-.87a.999.999 0 01.494-.032l.122.031 2.692.871.001-8.207A7.985 7.985 0 0136 41zm0-14a6 6 0 00-3.318 11H33v.197c.883.51 1.907.803 3 .803s2.118-.292 3.001-.803L39 38h.318A6 6 0 0036 27z"
            />
            <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M36 27a6 6 0 100 12 6 6 0 000-12z" />
            <rect width={4} height={4} x={34} y={31} fill={vars.bdlBoxBlue} rx={2} />
        </g>
    </AccessibleSVG>
);

export default Certificate56;
